import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {StatusDot} from 'shells/status-selector/status-dot';

import styles from './engagement-sidebar.module.css';

type Props = {
    icon: React.ReactNode;
    hasUnread: boolean;
};

export function IconWithStatusDot(props: Props) {
    return (
        <div className='pos-relative'>
            {props.icon}
            {props.hasUnread && (
                <div className={styles['status-dot-container']}>
                    <StatusDot color={colors.red} size={9} />
                </div>
            )}
        </div>
    );
}
